let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1pXoy")).then(() => parcelRequire('7kXdD'));